import { render, staticRenderFns } from "./BaseParagraph.vue?vue&type=template&id=1e90f95e&scoped=true&"
import script from "./BaseParagraph.vue?vue&type=script&lang=js&"
export * from "./BaseParagraph.vue?vue&type=script&lang=js&"
import style0 from "./BaseParagraph.vue?vue&type=style&index=0&id=1e90f95e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e90f95e",
  null
  
)

export default component.exports